module.exports = __webpack_public_path__ + "static/media/nature2.376659b6.svg";